import { render, staticRenderFns } from "./KYCRequestDetailModal.vue?vue&type=template&id=29d8fbc9&scoped=true"
import script from "./KYCRequestDetailModal.vue?vue&type=script&lang=js"
export * from "./KYCRequestDetailModal.vue?vue&type=script&lang=js"
import style0 from "./KYCRequestDetailModal.vue?vue&type=style&index=0&id=29d8fbc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8fbc9",
  null
  
)

export default component.exports